export function Table({ children }) {
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white text-sm">{children}</table>
      </div>
    )
  }
  
  export function TableHeader({ children }) {
    return <thead className="bg-gray-100">{children}</thead>
  }
  
  export function TableRow({ children }) {
    return <tr className="border-b">{children}</tr>
  }
  
  export function TableHead({ children }) {
    return <th className="px-4 py-2 text-left font-semibold text-gray-700">{children}</th>
  }
  
  export function TableBody({ children }) {
    return <tbody>{children}</tbody>
  }
  
  export function TableCell({ children }) {
    return <td className="px-4 py-2">{children}</td>
  }
  